import { render, staticRenderFns } from "./exercisesDetail.vue?vue&type=template&id=d3c9b80c&scoped=true&"
import script from "./exercisesDetail.vue?vue&type=script&lang=js&"
export * from "./exercisesDetail.vue?vue&type=script&lang=js&"
import style0 from "./exercisesDetail.vue?vue&type=style&index=0&id=d3c9b80c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c9b80c",
  null
  
)

export default component.exports